import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// maintenance router
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'misc-maintenance',
      component: () => import('@/views/error/Maintenance.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'misc-maintenance',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
